<template>
    <div>
        <q-table
            :data="user"
            :columns="columns"
            :pagination.sync="server_pagination"
            @request="request"
            :loading="loading"
            :filter="filter"
            row-key="name"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[5,10,50,100]"
            binary-state-sort
            >
            
            <template slot="top" slot-scope="props">
                <q-search v-model="filter" icon="far fa-search" :placeholder="$t('search')" :debounce="500" />
                <div class="col" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="user_id" :props="props">
                    {{ props.row.user_id }}
                </q-td>

                <q-td key="user_full_name" :props="props">
                    {{ props.row.user_full_name }}
                </q-td>

                <q-td key="user_email" :props="props">
                    {{ props.row.user_email }}
                </q-td>

                <q-td key="is_subscribed" :props="props">
                    <q-btn flat :text-color="subscribedColors(props.row.is_subscribed)" :icon="subscribedIcon(props.row.is_subscribed)" no-ripple />
                </q-td>

                <q-td key="subscribed_date" :props="props">
                    {{  fDate(props.row.subscribed_date) }}
                </q-td>

                <q-td key="checkin_date" :props="props">
                    {{  fDate(props.row.checkin_date) }}
                </q-td>
            </q-tr>
        </q-table>

        <div class="row gutter-sm justify-end q-mt-sm">
            <div class="col-xs-12 col-sm-3">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="$router.push({ name: 'events' })" />
            </div>
        </div>

        <q-dialog v-model="confirm_email_invite_users_to_event">
            <span slot="title">{{ $t('email_invite_users_to_event') }}</span>

            <span slot="message">{{ $t('confirm_sending_a_email_to_the_audience_of_this_event_with_an_invitation') }}</span>

            <template slot="buttons" slot-scope="props" :props="props">
                <q-btn color="primary" :label="$t('cancel')" @click="confirm_email_invite_users_to_event = false" />
                <q-btn color="positive" :label="$t('confirm')" @click="sendEmailInviteUsersToEvent()" />
            </template>
        </q-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
export default {
    data() {
        return {
            columns: [{
                align: 'left',
                field: 'user_id',
                label: '#',
                name: 'user_id',
                required: true,
                sortable: true
            }, {
                align: 'left',
                field: 'user_full_name',
                label: 'user_full_name',
                name: 'user_full_name',
                required: true,
                sortable: true
            }, {
                align: 'left',
                field: 'user_email',
                label: 'user_email',
                name: 'user_email',
                required: true,
                sortable: false
            }, {
                align: 'left',
                field: 'is_subscribed',
                label: 'is_subscribed',
                name: 'is_subscribed',
                required: true,
                sortable: true
            }, {
                align: 'left',
                field: 'subscribed_date',
                label: 'subscribed_date',
                name: 'subscribed_date',
                required: true,
                sortable: true
            }, {
                align: 'left',
                field: 'checkin_date',
                label: 'checkin_date',
                name: 'checkin_date',
                required: true,
                sortable: true
            }],
            confirm_email_invite_users_to_event: false,
            filter: '',
            id_event: '',
            loading: false,
            server_pagination: {
                descending: false,
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                sortBy: null
            },
            user: []
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            num_rows: 'datatable/num_rows',
            id_user_language_selected: 'common/id_user_language_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        request ({ pagination }) {
            this.loadPagination()

            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter,
                "ordering": order_by
            }

            this.savePagination()

            this.$axios.get(`/admin_rewards/events_qrcode/${this.id_event}/participants/?` + this.$qs.stringify(data), this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count
                this.user = response.data.results.map( u => ({...u, action: {lat:u.checkin_lat, long: u.checkin_long}}))
                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        subscribedIcon(value) {
            if(value) return "fas fa-check"
            else return "fas fa-times"
        },

        subscribedColors (value) {
            if(value) return "positive"
            else return "negative"
        },

        showMap(value) {
            if (this.$q.platform.is.cordova && this.$q.platform.is.ios) {
                cordova.InAppBrowser.open(`http://maps.google.com/?q=${value.lat},${value.long}`, '_system', 'usewkwebview=yes,hidenavigationbuttons=yes,toolbar=no')
            }
            else {
                window.open(`http://maps.google.com/?q=${value.lat},${value.long}`, '_blank')
            }
        },

        disabledButton(value){
            if(value.lat == null && value.long == null) return 'disabled'
        },

        sendEmailInviteUsersToEvent() {
            this.confirm_email_invite_users_to_event = false
        }
    },

    created() {
        this.id_event = this.$route.params.id
        if (this.id_event != 0) {
            this.request({
                pagination: this.server_pagination
            })
        }
    }
}
</script>

<style>

</style>